import { createSelector } from '@ngrx/store';

import { getAppLoadingStatus$ } from './apps.selector';
import { getInstancesLoadingStatus$, getInstancesStatusesLoadingStatus$ } from './instances.selector';
import { getReconTemplatesLoading$, getRequestLoading$ } from './requests.selector';
import {
    getChainLoadingStatus$,
    getInboundLoadingStatus$,
    getOutboundLoadingStatus$,
    getTransformationDetailLoadingStatus$,
} from './transformations.selector';

export const getCompleteAppLoadingStatus$ = (serviceId: string, restApiName: string) =>
    createSelector(
        getAppLoadingStatus$(serviceId),
        getInboundLoadingStatus$(restApiName),
        getOutboundLoadingStatus$(restApiName),
        getChainLoadingStatus$(restApiName),
        getTransformationDetailLoadingStatus$(restApiName),
        getInstancesLoadingStatus$(serviceId),
        getInstancesStatusesLoadingStatus$(serviceId),
        getRequestLoading$(serviceId),
        getReconTemplatesLoading$(serviceId),
        (app, inbound, outbound, chainNames, transformationDetail, instances, statuses, requests, templates) =>
            app?.meta ||
            app?.template ||
            app?.reconConfiguration ||
            inbound ||
            outbound ||
            chainNames ||
            transformationDetail ||
            instances ||
            statuses ||
            requests ||
            templates ||
            false
    );
